/* cf-ui-guards.js — Click Fencing, 2026-09-26. Three customer-facing guards from the Lenovo
 * break test (_inbox/agent-results/2026-09-26-click-break-test.md), all four calculators and
 * the quote page. Nothing here edits a calculator; it only stops a keystroke or a stray click.
 *
 * 1. DECIMALS IN SECTION LENGTH (break test F1). Every calculator strips non-digits from
 *    #section-N-length, so "1234.5" became 12345 — a fence ten times too long, no warning.
 *    Pete: "just remove the decimal". The point and anything typed after it are dropped:
 *    1234.5 → 1234. Keystrokes via beforeinput (works for phone keyboards too); paste and
 *    autofill via a capture-phase input pass that cuts at the first "." or ",".
 *
 * 2. LETTERS EMPTY THE BOX BUT THE OLD PRICE STAYS (F5). The calculators return early on an
 *    empty value, so the quote kept the previous length while the box showed nothing — the
 *    customer would be charged for a length not written anywhere. If the box is left empty,
 *    the last length the calculator is using is put back in it, so what they see is what
 *    they pay for.
 *
 * 3. A POP-UP CLOSED BY DRAGGING OUT OF IT (Pete, 26 Sep: "if you accidentally click drag the
 *    mouse out of the pop out it disappears. make so you actually have to click out of the
 *    window for it to disappear"). Press inside the details box, release over the dark
 *    backdrop, and the browser fires a click on the backdrop — which every "click outside to
 *    close" handler takes as a close. A click on a full-screen backdrop now only counts if
 *    the press ALSO started on that backdrop. Applies to every full-screen overlay on the site.
 */
(function () {
  'use strict';
  if (window.__cfUiGuards) return;
  window.__cfUiGuards = true;

  var LEN = /^section-\d+-length$/;
  function isLen(el) { return !!(el && el.id && LEN.test(el.id) && el.tagName === 'INPUT'); }

  /* ── 1. decimals ─────────────────────────────────────────────────────────── */
  document.addEventListener('beforeinput', function (e) {
    var el = e.target;
    if (!isLen(el)) return;
    var t = e.inputType || '';
    if (/^delete/.test(t)) { el.__cfDec = false; return; }
    if (t !== 'insertText' && t !== 'insertCompositionText') return;
    var d = e.data || '';
    if (/[.,]/.test(d)) { el.__cfDec = true; e.preventDefault(); return; }
    if (el.__cfDec && /^\d+$/.test(d)) {
      /* still typing the decimal part: only swallow digits added at the END of the box */
      var atEnd = el.selectionStart === el.value.length && el.selectionEnd === el.value.length;
      if (atEnd) e.preventDefault();
      else el.__cfDec = false;
    }
  }, true);
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!isLen(el)) return;
    var v = String(el.value || '');
    if (/[.,]/.test(v)) el.value = v.split(/[.,]/)[0];   // paste / autofill / no beforeinput
  }, true);
  document.addEventListener('focusin', function (e) { if (isLen(e.target)) e.target.__cfDec = false; }, true);

  /* ── 2. an emptied box gets its real length back ─────────────────────────── */
  document.addEventListener('focusout', function (e) {
    var el = e.target;
    if (!isLen(el)) return;
    el.__cfDec = false;
    setTimeout(function () {
      try {
        if (String(el.value || '').replace(/[^0-9]/g, '') !== '') return;
        var n = parseInt(el.id.split('-')[1], 10);
        var gc = window.glassCalculator || window.glassFencingCalculator;
        var cur = gc && gc.state && gc.state.sections && gc.state.sections[n] && gc.state.sections[n].length;
        if (cur && parseInt(cur, 10) > 0) el.value = String(parseInt(cur, 10));
      } catch (x) {}
    }, 0);
  }, true);

  /* ── 3. drag-out must not close a pop-up ─────────────────────────────────── */
  var downTarget = null;
  function isBackdrop(el) {
    if (!el || el === document.body || el === document.documentElement || !el.getBoundingClientRect) return false;
    try {
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed') return false;
      var r = el.getBoundingClientRect();
      return r.width >= window.innerWidth * 0.9 && r.height >= window.innerHeight * 0.9;
    } catch (x) { return false; }
  }
  document.addEventListener('pointerdown', function (e) { downTarget = e.target; }, true);
  document.addEventListener('mousedown', function (e) { downTarget = e.target; }, true);
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!isBackdrop(t)) return;
    if (downTarget && downTarget !== t && t.contains(downTarget)) {
      /* pressed inside the box, released over the backdrop: not a click-outside */
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);

  /* ── 3b. "Delete section" asks on the page, not in a plain browser box (F19) ────
     cf-section-add-remove.js calls window.confirm(). The click is caught first and an
     on-brand question is shown under the button; "Delete" then lets the original click
     through with the answer already given. */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.cf-section-mgmt') : null;
    if (!b || !/^Delete/.test((b.textContent || '').trim()) || b.__cfAllowed) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var old = document.getElementById('cf-del-ask'); if (old) old.remove();
    var box = document.createElement('div');
    box.id = 'cf-del-ask';
    box.setAttribute('role', 'alertdialog');
    box.style.cssText = 'position:absolute;z-index:2147483000;background:#fff;border:1px solid #fca5a5;border-radius:10px;'
      + 'box-shadow:0 14px 34px -14px rgba(0,0,0,.45);padding:12px 14px;font:inherit;font-size:14px;color:#111827;max-width:300px';
    var label = (b.textContent || '').trim().replace(/^Delete\s*/, '') || 'this section';
    var t = document.createElement('div'); t.style.cssText = 'font-weight:700;margin-bottom:4px';
    t.textContent = 'Delete ' + label + '?';
    var p = document.createElement('div'); p.style.cssText = 'color:#475569;font-size:13px;margin-bottom:10px';
    p.textContent = 'Anything entered for it will be lost.';
    var yes = document.createElement('button'); yes.type = 'button'; yes.textContent = 'Delete';
    yes.style.cssText = 'min-height:40px;padding:0 14px;border:0;border-radius:6px;background:#b91c1c;color:#fff;font:inherit;font-weight:700;cursor:pointer;margin-right:8px';
    var no = document.createElement('button'); no.type = 'button'; no.textContent = 'Keep it';
    no.style.cssText = 'min-height:40px;padding:0 14px;border:1px solid #cbd5e1;border-radius:6px;background:#fff;color:#111827;font:inherit;font-weight:600;cursor:pointer';
    box.appendChild(t); box.appendChild(p); box.appendChild(yes); box.appendChild(no);
    document.body.appendChild(box);
    var r = b.getBoundingClientRect();
    box.style.top = (window.scrollY + r.bottom + 6) + 'px';
    box.style.left = Math.max(8, Math.min(window.scrollX + r.left, window.scrollX + window.innerWidth - box.offsetWidth - 8)) + 'px';
    no.addEventListener('click', function () { box.remove(); });
    yes.addEventListener('click', function () {
      box.remove();
      var realConfirm = window.confirm;
      window.confirm = function () { return true; };
      b.__cfAllowed = true;
      try { b.click(); } finally { b.__cfAllowed = false; window.confirm = realConfirm; }
    });
    setTimeout(function () { try { yes.focus(); } catch (x) {} }, 20);
  }, true);

  /* ── 4. wording and layout polish from the same break test (text and CSS only) ── */
  var CALC_PAGES = /^\/pages\/(glass-fencing|blade-fence-calculator|flat-top-fence-calculator|perfmesh-fence)\/?$/;
  var onCalc = CALC_PAGES.test(location.pathname);

  var css = document.createElement('style');
  css.id = 'cf-ui-guards-css';
  css.textContent = [
    /* F11: iPad portrait — the two-column Configure layout hung 100 px off the screen */
    '@media (min-width:641px) and (max-width:900px){',
    '#configure-sections .calculator-layout.configure-layout{display:grid!important;grid-template-columns:minmax(0,1fr)!important;width:auto!important;min-width:0!important;max-width:100%!important}',
    '#configure-sections .configure-layout>.calculator-column{width:auto!important;max-width:100%!important;min-width:0!important}}',
    /* F18: step 1 had a second identical "Next →" and a "← Back" that goes nowhere */
    'html.cf-step1 #nav-next,html.cf-step1 #nav-back{display:none!important}',
    /* F24: the most important field and the phone number were too small to tap */
    '@media (max-width:640px){input[id^="section-"][id$="-length"]{min-height:44px!important;font-size:16px!important}',
    'a[href^="tel:"]{display:inline-block;padding:10px 2px}}',
    '.cf-len-hint{display:none;margin:6px 0 0;padding:7px 10px;border-radius:6px;background:#fef3c7;color:#92400e;font-size:13px;line-height:1.4}',
    '.cf-len-hint.on{display:block}',
    '.cf-gst-note{margin:8px 0 0;font-size:12.5px;color:#475569;text-align:right}'
  ].join('');
  (document.head || document.documentElement).appendChild(css);

  var MIN_LEN = 300;   // calculators accept 100; under 300 is almost always metres or centimetres typed by mistake
  function lenHint(el) {
    /* F7: 0, 50 or "4" priced at $0 with no explanation — say what the box wants */
    var id = el.id + '-cf-hint', h = document.getElementById(id);
    var v = parseInt(String(el.value || '').replace(/[^0-9]/g, ''), 10) || 0;
    var show = v > 0 && v < MIN_LEN;
    if (!h) {
      if (!show) return;
      h = document.createElement('div');
      h.id = id; h.className = 'cf-len-hint';
      el.insertAdjacentElement('afterend', h);
    }
    h.textContent = 'Lengths are in millimetres — for example 4 metres is 4000.';
    h.classList.toggle('on', show);
  }
  document.addEventListener('input', function (e) {
    /* while typing, only ever HIDE it — "4" on the way to "4000" is not a mistake */
    if (!isLen(e.target)) return;
    var h = document.getElementById(e.target.id + '-cf-hint');
    var v = parseInt(String(e.target.value || '').replace(/[^0-9]/g, ''), 10) || 0;
    if (h && v >= MIN_LEN) h.classList.remove('on');
  }, false);
  document.addEventListener('focusout', function (e) { if (isLen(e.target)) setTimeout(function () { lenHint(e.target); }, 10); }, true);

  function eachText(root, re, fn) {
    if (!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, hits = [];
    while ((n = w.nextNode())) if (re.test(n.nodeValue)) hits.push(n);
    hits.forEach(fn);
  }

  function polish() {
    try {
      var add = document.getElementById('add-sections');
      document.documentElement.classList.toggle('cf-step1', !!(onCalc && add && add.classList.contains('active')));
      if (onCalc) {
        /* F8: the note under Delivery said "$99 flat rate" beside a FREE delivery line */
        var note = document.getElementById('delivery-note');
        if (note && /\$99 flat rate/.test(note.textContent)) {
          var rev = document.getElementById('review-checkout') || document.body;
          if (/Delivery[^\n]*FREE/i.test(rev.innerText || '')) {
            note.textContent = 'Delivery to your door — FREE Perth metro delivery on orders over $3,000, and this order qualifies.';
          }
        }
        /* F9 + F16: the Configuration Summary's labels */
        var sum = document.getElementById('quote-summary');
        eachText(sum, /^\s*Panel\s*$/, function (n) { n.nodeValue = n.nodeValue.replace('Panel', 'Max panel length'); });
        eachText(sum, /Fence Type:/, function (n) { n.nodeValue = n.nodeValue.replace('Fence Type:', 'Spigot Type:'); });
        /* F17: the button opens a message TO us, it does not email the customer */
        var em = document.getElementById('email-quote');
        if (em && /Email me this quote/.test(em.textContent)) em.textContent = '📧 Send this quote to us';
        /* F15: say GST is included, once, under the Review total */
        var rv = document.getElementById('review-checkout');
        if (rv && rv.classList.contains('active') && !document.getElementById('cf-gst-note')) {
          var tots = rv.querySelectorAll('.breakdown-total');
          var tot = tots.length ? tots[tots.length - 1] : null;
          if (tot) {
            var g = document.createElement('div');
            g.id = 'cf-gst-note'; g.className = 'cf-gst-note';
            g.textContent = 'All prices include GST.';
            tot.insertAdjacentElement('afterend', g);
          }
        }
      }
      /* F22: on a phone a long fence scrolls inside its band (Pete 28 Aug, cf-preview-mobile-band)
         — say so, so it never looks cut off */
      if (onCalc) {
        var pv = document.getElementById('section-preview');
        var hint = document.getElementById('cf-swipe-hint');
        var needs = !!(pv && window.innerWidth <= 749 && pv.offsetParent && pv.scrollWidth > pv.clientWidth + 4);
        if (needs && !hint) {
          hint = document.createElement('div');
          hint.id = 'cf-swipe-hint';
          hint.style.cssText = 'font-size:12.5px;color:#475569;text-align:center;margin:4px 0 6px';
          hint.textContent = 'Swipe the drawing, or tap ›, to see your whole fence.';
          pv.insertAdjacentElement('afterend', hint);
        }
        if (hint) hint.style.display = needs ? '' : 'none';
      }
      /* F21: picture-only menu links had no name for screen readers */
      [].slice.call(document.querySelectorAll('a[href]')).forEach(function (a) {
        if (a.getAttribute('aria-label') || (a.textContent || '').trim()) return;
        var img = a.querySelector('img');
        var name = img && (img.getAttribute('alt') || '').trim();
        if (!name) { var h = a.getAttribute('href') || ''; var m = /\/(pages|collections)\/([^/?#]+)/.exec(h); if (m) name = m[2].replace(/-/g, ' '); }
        if (name) a.setAttribute('aria-label', name);
      });
    } catch (x) {}
  }
  polish();
  setInterval(polish, 1000);

  try { console.log('[cf-ui-guards] installed'); } catch (x) {}
})();
